// HOW TO の各ステップで、スタンプがウィンドウ縦中央を超えたら「印」→「済」に押印し、
// 戻ったら「印」に戻す（スクロールに追従する可逆演出）
window.addEventListener('load', () => {
  const steps = document.querySelectorAll('.konintodoke-top-basic-step')
  if (!steps.length) return

  const update = () => {
    const center = window.innerHeight / 2
    steps.forEach((step) => {
      const stamp = step.querySelector('.konintodoke-top-basic-step__stamp')
      if (!stamp) return
      const rect = stamp.getBoundingClientRect()
      const stampMiddle = rect.top + rect.height / 2
      // スタンプの中心が画面中央より上に来たら押印
      step.classList.toggle('is-stamped', stampMiddle < center)
    })
  }

  let ticking = false
  const onScroll = () => {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(() => {
      update()
      ticking = false
    })
  }

  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })
})
